import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import * as ModalContainer from 'ui-library/ModalContainer';
import ifCreateFromHash from 'util/ifCreateFromHash';

import ImportSequenceForHRTemplateModal from './hr-template/ImportSequenceForHRTemplateModal';

class CreateHRTemplateLink extends Backbone.View {
  render() {
    const onRequestClose = () => {
      ModalContainer.close(ImportSequenceForHRTemplateModal);
    };

    const openImportSequenceForHRTemplateModal = () => {
      ModalContainer.open(
        ImportSequenceForHRTemplateModal,
        <ImportSequenceForHRTemplateModal onRequestClose={onRequestClose} />
      );
    };

    $(document).on('click', '.js-create-new-hr-template', (e) => {
      e.preventDefault();
      openImportSequenceForHRTemplateModal();
      analytics.track('hr_template', 'open_import_modal_from_create');
    });

    ifCreateFromHash('#create/hr-template', () => {
      openImportSequenceForHRTemplateModal();
      analytics.track('hr_template', 'open_import_modal_from_hash');
    });
    return this;
  }
}

export default CreateHRTemplateLink;
